import {Injectable} from "@angular/core";
import {RestService} from "../../../shared/services/rest.service";

@Injectable({
  providedIn: 'root'
})
export class AnimalChangeShelterService {

  constructor(
    private readonly _restService: RestService
  ) {
  }

  getShelterChangeHistories(animalId: number) {
    return this._restService.httpGet(`/animal_shelter_changes?animal.id=${animalId}`);
  }

  changeShelter(animalId: number, newShelterId: number, newShelterChangeDate: string) {
    return this._restService.httpPost(`/animals/${animalId}/change-shelter/${newShelterId}`, {newShelterChangeDate});
  }

  undoShelterChange(historyId: number) {
    return this._restService.httpPost(`/undo-shelter-change/${historyId}`, {});
  }
}
